import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router';
import { App } from './App';
import { createAppQueryClient, enableQueryPersistence } from './services/queryClient';
import { applyTheme } from './shared/theme';
import { ToastProvider } from './shared/toast';
import { ConfirmProvider } from './shared/confirm';
import { AuthProvider } from './shared/AuthContext';
import { registerSW } from 'virtual:pwa-register';
import './styles/global.css';

applyTheme();

const queryClient = createAppQueryClient();
enableQueryPersistence(queryClient);

// Service Worker zero-touch: con registerType 'autoUpdate' + immediate, quando
// un deploy pubblica un nuovo SW questo si attiva (skipWaiting/clientsClaim) e la
// pagina si ricarica DA SOLA sulla nuova versione — niente Ctrl+Shift+R manuale.
registerSW({ immediate: true });

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Root element #root non trovato');

createRoot(rootEl).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AuthProvider>
          <ToastProvider>
            <ConfirmProvider>
              <App />
            </ConfirmProvider>
          </ToastProvider>
        </AuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
